import React, { useEffect, useState } from 'react';
import axiosInstance from '../api/axiosInstance';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Paper } from '@mui/material';
import DateFormatter from '../utils/DateFormatter';

const TeamMemberList = ({ teamId }) => {
  const [members, setMembers] = useState([]);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('email'); // Default column for sorting

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const response = await axiosInstance.get(`/api/team/members/${teamId}`);
        if (Array.isArray(response.data)) {
          setMembers(response.data);
        } else {
          console.error('Expected an array, but received:', response.data);
        }
      } catch (error) {
        console.error("Error fetching team members:", error);
      }
    };
    fetchMembers();
  }, [teamId]);

  if (members.length === 0) return <div>No team members found</div>;

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const sortData = (array, comparator) => {
    const stabilizedArray = array.map((el, index) => [el, index]);
    stabilizedArray.sort((a, b) => {
      const orderComparison = comparator(a[0], b[0]);
      if (orderComparison !== 0) return orderComparison;
      return a[1] - b[1];
    });
    return stabilizedArray.map((el) => el[0]);
  };

  const comparator = (a, b) => {
    if (a[orderBy] < b[orderBy]) {
      return order === 'asc' ? -1 : 1;
    }
    if (a[orderBy] > b[orderBy]) {
      return order === 'asc' ? 1 : -1;
    }
    return 0;
  };

  const sortedMembers = sortData(members, comparator);

  return (
    <div>
      <h3>Team Members</h3>
      <TableContainer component={Paper} style={{ maxHeight: '400px', overflow: 'auto' }}>
        <Table aria-labelledby="tableTitle">
          <TableHead>
            <TableRow>
              <TableCell sortDirection={orderBy === 'email' ? order : false}>
                <TableSortLabel
                  active={orderBy === 'email'}
                  direction={orderBy === 'email' ? order : 'asc'}
                  onClick={() => handleRequestSort('email')}
                >
                  Email
                </TableSortLabel>
              </TableCell>
              <TableCell sortDirection={orderBy === 'first_seen' ? order : false}>
                <TableSortLabel
                  active={orderBy === 'first_seen'}
                  direction={orderBy === 'first_seen' ? order : 'asc'}
                  onClick={() => handleRequestSort('first_seen')}
                >
                  First Seen
                </TableSortLabel>
              </TableCell>
              <TableCell sortDirection={orderBy === 'last_seen' ? order : false}>
                <TableSortLabel
                  active={orderBy === 'last_seen'}
                  direction={orderBy === 'last_seen' ? order : 'asc'}
                  onClick={() => handleRequestSort('last_seen')}
                >
                  Last Seen
                </TableSortLabel>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedMembers.map((member) => (
              <TableRow hover role="checkbox" tabIndex={-1} key={`${member.id}-${member.email}`}>
                <TableCell>
                  <a href={`/user/${member.id}`}>{member.email}</a>
                </TableCell>
                <TableCell>{DateFormatter.formatDate(member.first_seen)}</TableCell>
                <TableCell>{DateFormatter.formatDate(member.last_seen)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default TeamMemberList;
